import React from 'react'
import img from '../../../public/static/image-background/logo-v-02.png'
import { getBase64, useTranslation } from '../../../constants/helpers'

const Mau3 = ({ dataSeason, dataTable, size, id }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100

    const color = {
        first: '#00e5ff',    // Neon Cyan
        second: '#00b4d8',   // Ocean Blue
        third: '#0077b6',    // Deep Blue
        fourth: '#90e0ef',   // Light Cyan
        gold: '#FFD700',     // Gold accent
        text: '#ffffff',
        bg: '#030816'        // Deep Dark Navy
    }

    return (
        <div id={id} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg, position: 'relative', overflow: 'hidden' }}>

            {/* Grid background */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0,
                backgroundImage: `linear-gradient(rgba(0,229,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,229,255,0.03) 1px, transparent 1px)`,
                backgroundSize: `${px * 5}px ${px * 5}px`
            }} />
            {/* Radial glow */}
            <div style={{ position: 'absolute', top: '30%', left: '50%', transform: 'translate(-50%, -50%)', width: `${px * 100}px`, height: `${px * 80}px`, background: 'radial-gradient(ellipse, rgba(0,180,216,0.1) 0%, transparent 70%)', zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1, width: '100%', padding: `${px * 1.5}px`, display: 'flex', flexDirection: 'column' }}>

                {/* Header */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderBottom: `2px solid rgba(0,229,255,0.35)`, paddingBottom: `${px * 1.5}px`, marginBottom: `${px * 2}px` }}>
                    <div style={{ flex: 1 }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 6px rgba(0,229,255,0.8))` }} />
                    </div>
                    <div style={{ flex: 6 }}>
                        <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${2.8 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.2}px`, textShadow: `0 0 12px ${color.first}`, margin: 0 }}>{dataSeason?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <Image src={img} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain' }} />
                    </div>
                </div>

                {/* Title */}
                <div style={{ textAlign: 'center', marginBottom: `${px * 3}px` }}>
                    <h1 style={{ color: color.first, fontSize: `${5.5 * px}px`, textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: `${px * 0.3}px`, textShadow: `0 0 20px ${color.first}, 0 0 40px ${color.second}`, margin: 0, lineHeight: 1.1 }}>
                        {t('final_draw')}
                    </h1>
                </div>

                {/* Group cards grid */}
                <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: `${px * 2}px` }}>
                    {dataTable?.map((group, idx) => (
                        <GroupCard key={`${idx}${new Date()}`} data={group} px={px} color={color} idx={idx} classCustom={`${group.name}`} t={t} />
                    ))}
                </div>

                {/* Footer */}
                <p style={{ textAlign: 'right', color: `rgba(144,224,239,0.5)`, fontSize: `${2 * px}px`, fontWeight: 'bold', margin: `${px * 3}px 0 0 0` }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORT EXCLUSIVE'}
                </p>
            </div>
        </div>
    )
}

const GroupCard = React.memo(
    ({ data, px, color, idx, classCustom, t }) => {
        return (
            <div style={{
                width: `${44 * px}px`,
                background: 'rgba(3,8,30,0.85)',
                border: `1px solid rgba(0,229,255,0.4)`,
                borderRadius: `${px * 1.5}px`,
                overflow: 'hidden',
                boxShadow: `0 0 20px rgba(0,229,255,0.12), inset 0 0 15px rgba(0,180,216,0.05)`,
                backdropFilter: 'blur(8px)'
            }}>
                {/* Group header */}
                <div style={{
                    background: `linear-gradient(90deg, rgba(0,119,182,0.6) 0%, rgba(0,229,255,0.25) 50%, rgba(0,119,182,0.6) 100%)`,
                    borderBottom: `1px solid rgba(0,229,255,0.4)`,
                    padding: `${px * 1}px`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <span style={{ color: color.first, fontSize: `${2.4 * px}px`, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px', textShadow: `0 0 10px ${color.first}` }}>
                        {t('group')} {data?.name}
                    </span>
                </div>

                {/* Teams list */}
                <div style={{ padding: `${px * 0.5}px ${px * 1.2}px` }}>
                    {data?.teams?.map((team, teamIdx) => (
                        <div key={`${teamIdx}${team.id}`} style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'row',
                            borderTop: teamIdx !== 0 ? `1px solid rgba(0,229,255,0.15)` : 'none',
                            paddingTop: teamIdx !== 0 ? `${px * 0.8}px` : 0,
                            marginTop: teamIdx !== 0 ? `${px * 0.8}px` : 0,
                            paddingBottom: `${px * 0.3}px`
                        }}>
                            {/* Seat number badge */}
                            <div style={{
                                minWidth: `${px * 5}px`,
                                height: `${px * 3}px`,
                                background: `rgba(0,229,255,0.12)`,
                                border: `1px solid rgba(0,229,255,0.35)`,
                                borderRadius: `${px * 0.5}px`,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: `${px * 1}px`,
                                flexShrink: 0
                            }}>
                                <span style={{ color: color.first, fontSize: `${1.6 * px}px`, fontWeight: 'bold' }}>
                                    {data?.name}{teamIdx + 1}
                                </span>
                            </div>
                            {/* Team name */}
                            <TeamName name={team.name} px={px} propClass={`tableClass${classCustom}${teamIdx}${new Date().getTime()}`} color={color.text} />
                        </div>
                    ))}
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

const TeamName = React.memo(
    ({ name, px, propClass, color }) => {
        const reSizeBasedOnWidth = () => {
            let fontSize = window && window?.getComputedStyle(document.querySelector(`.${propClass}`))?.fontSize
            if (fontSize) {
                document.querySelector(`.${propClass}`).style.fontSize = parseFloat(fontSize) - 0.01 * px + 'px'
                if (document.querySelector(`.${propClass}`).clientHeight >= document.querySelector(`.contain${propClass}`).clientHeight) {
                    reSizeBasedOnWidth()
                }
            }
        }
        const processInput = () => {
            if (document.querySelector(`.${propClass}`)) {
                document.querySelector(`.${propClass}`).innerHTML = name
                document.querySelector(`.${propClass}`).style.fontSize = px * 2.2 + 'px'
                reSizeBasedOnWidth()
            }
        }
        React.useEffect(() => {
            processInput()
        }, [name])

        return (
            <div className={`contain${propClass}`} style={{ flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', height: `${3.2 * px}px`, overflow: 'hidden' }}>
                <h2 className={propClass} style={{ color: color, marginLeft: `${px * 0.5}px`, textTransform: 'uppercase', fontFamily: 'SFUHelveticaCondensedBoldOblique', margin: 0 }}></h2>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSeason) === JSON.stringify(n.dataSeason) &&
        JSON.stringify(p.dataTable) === JSON.stringify(n.dataTable)
}

export default React.memo(Mau3, areEqual)
